import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import ResetPasswordSuccesMessage from '../../components/ReserPasswordSuccesMessage/ResetPasswordSuccesMessage';
import { localeStore } from 'src/mobx/localesStore';
import { userStore } from 'src/mobx/userStore';
import { emailValidation } from 'src/utils/validation';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Input from 'src/view/components/Controls/Input/Input';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import logger from '~/services/logger';
import './style.scss';

interface Props {
  isOpen: boolean;
  closeForgotPassModal: () => void;
}

export default class ResetPasswordModal extends Component<Props> {
  state = {
    email: '',
    token: '',
    loading: false,
    isValid: false,
    resetSuccesModal: false,
  };

  openResetSuccesModal = () => {
    this.setState({ resetSuccesModal: true });
    setTimeout(this.closeResetSuccesModal, 5000);
  };

  closeResetSuccesModal = () => {
    this.setState({ resetSuccesModal: false });
  };

  onChangeField = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      this.setState({ email: event.target.value, isValid: emailValidation(event.target.value).isValid });
    } catch (error: any) {
      logger.error({ error, place: 'ResetPasswordModal onChangeField' });
    }
  };

  onCaptchaVerified = (token: string | null) => {
    if (token) {
      this.setState({ token });
    }
  };

  submit = async (event: React.FormEvent) => {
    try {
      if (event) event.preventDefault();

      this.setState(() => ({ loading: true }));
      const response = await userStore.resetPassword({
        email: this.state.email,
        token: this.state.token,
      });

      if (response) {
        this.props.closeForgotPassModal();
        this.openResetSuccesModal();
      }

      this.setState(() => ({ loading: false }));
    } catch (error: any) {
      this.setState(() => ({ loading: false }));
      logger.error({ error, place: 'ResetPasswordModal submit', showModal: true });
    }
  };

  render() {
    return (
      <div>
        <CustomModalComponent
          isOpen={this.props.isOpen}
          onRequestClose={this.props.closeForgotPassModal}
          withCloseIcon={true}
          className="reset-password-modal"
          iconClassName="color-gray2"
          shouldCloseOnOverlayClick={false}
        >
          <ModalBackground>
            <ModalHeader title={localeStore.t('password_recovery')} />
            <form name="reset" onSubmit={this.submit} className="reset-password-modal__form d-flex flex-column align-items-center">
              <p className="reset-password-modal__text color-dark text-size-24 mt-12 mx-14 text-center">
                {localeStore.t('input_your_email_to_reset_password')}
              </p>
              <Input
                onChange={this.onChangeField}
                disabled={this.state.loading}
                error={!this.state.isValid}
                placeholder={localeStore.t('email_placeholder')}
                className="reset-password-modal__input text-size-18 family-medium mt-8 ml-8"
              />
              {process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY ? (
                <div className="g-recaptcha pl-8 mt-6">
                  <ReCAPTCHA sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY} onChange={this.onCaptchaVerified} />
                </div>
              ) : null}
              <Button
                type="submit"
                title={localeStore.t('reset_password')}
                disabled={this.state.loading || !this.state.isValid || !this.state.token.length}
                loading={this.state.loading}
                size="large"
                className="reset-password-modal__button"
              />
            </form>
          </ModalBackground>
        </CustomModalComponent>
        <ResetPasswordSuccesMessage isOpen={this.state.resetSuccesModal} closeResetSuccesModal={this.closeResetSuccesModal} />
      </div>
    );
  }
}
